<template>
  <AtomicUiCard class="search-registry cell small-12 medium-12 large-12 xlarge-12" padding-class="padding-top-l padding-bottom-l">
    <div class="grid-container">
      <div class="grid-x grid-margin-x align-middle margin-bottom-xxl">
        <div class="cell small-12 medium-12 large-12 xlarge-12">
          <div class="h2 text-center main-header">Find a registry to give a gift</div>
        </div>
      </div>
      <RegistryUiSearchRegistryBarForm />
    </div>
  </AtomicUiCard>
</template>

<style lang="scss" scoped>
@import '~@core/foundation/scss/foundation-6.7.4/scss/prototype/_spacing.scss';
.search-registry {
  border: $white !important;
  background-color: $background-color;
}

.search-registry-bar {
  :deep(.input-container) {
    @include margin-direction('bottom', map-get($spacer, 'xxs'));
  }

  :deep(.search-registry-button) {
    @include breakpoint(small only) {
      @include margin-direction('top', map-get($spacer, 's'));
    }
    @include breakpoint(medium up) {
      @include margin-direction('top', map-get($spacer, 'xs'));
    }
    @include breakpoint(large up) {
      min-width: rem-calc(195);
    }
  }

  :deep(.search-registry-bar-input-wrapper) {
    @include breakpoint(medium up) {
      margin-right: rem-calc(12);
    }

    .input-container {
      @include breakpoint(small only) {
        margin-top: rem-calc(9);
      }
    }
  }

  :deep(.search-registry-bar-button-wrapper) {
    @include breakpoint(medium up) {
      margin-left: rem-calc(12);
    }
  }

  @include breakpoint(large up) {
    padding-left: rem-calc(21);
    padding-right: rem-calc(21);
  }
}
.sub-header {
  font-weight: 500;
}
</style>
